module.exports = __webpack_public_path__ + "media/night/320-f4e044b5.svg";